/**
 * Ön plan FCM — web: firebase/messaging `onMessage`
 */
import { getApp } from 'firebase/app';
import { getMessaging, isSupported, onMessage } from 'firebase/messaging';

export type ForegroundPayload = {
  title?: string;
  body?: string;
};

export function subscribeForegroundMessages(
  handler: (payload: ForegroundPayload) => void,
): () => void {
  let messagingUnsub: (() => void) | undefined;
  let cancelled = false;

  void (async () => {
    if (!(await isSupported()) || cancelled) {
      return;
    }
    const messaging = getMessaging(getApp());
    messagingUnsub = onMessage(messaging, payload => {
      handler({
        title: payload.notification?.title,
        body: payload.notification?.body,
      });
    });
  })();

  return () => {
    cancelled = true;
    messagingUnsub?.();
  };
}
